import {
  AGENCY_PLANS,
  AvailablePlansTypes,
  PlanRecordKeyTypes,
  PROFESSIONAL_PLANS
} from '@constants/plans'

const ALLOWED_PLANS = [...PROFESSIONAL_PLANS, ...AGENCY_PLANS]

export const isAvailablePlan = (
  recordKey: PlanRecordKeyTypes
): recordKey is AvailablePlansTypes => {
  return ALLOWED_PLANS.some(plan => plan === recordKey)
}
